import { useQuery } from "@tanstack/react-query";

import { MODULE_NAMES } from "@/constants/modules";
import { LIST_QUERY_KEY } from "@/utils/query";

import { fetchStatisticsGroups } from "./statisticsApi";

export const useStatisticsGroups = () =>
  useQuery({
    queryKey: [MODULE_NAMES.STATISTICS_GROUPS, LIST_QUERY_KEY],
    queryFn: async () => {
      const { data } = await fetchStatisticsGroups();
      return data;
    },
    staleTime: Infinity,
  });
